import { type FC } from 'react';

/**
 * Ambient orbs — drifting colored blobs that give the background enough
 * saturated color for the liquid-glass surfaces to visibly refract.
 *
 * Two variants:
 *   - `variant="login"` (3 orbs, softer) — for the login page
 *   - `variant="app"`   (4 orbs, richer) — for the main application
 *
 * Orbs honor `prefers-reduced-motion` via the .orb class in globals.css
 * (animation: none).
 */

export interface OrbsProps {
  variant?: 'login' | 'app';
}

/**
 * Retired in the flat Material-3 refresh — the ambient orb background is gone.
 * Kept as a no-op so existing imports (e.g. login) don't break.
 */
export const Orbs: FC<OrbsProps> = () => null;

export default Orbs;
